import { Button, Flex, Stack, Text } from "@chakra-ui/react";
import { format } from "date-fns";
import * as React from "react";
import { getWeekDay } from "../utils/functions";
import Icon from "../components/ui-elements/Icon";

type Props = {
  assignedSupport: any;
  bookingDuration: any;
  host: string;
  [key: string]: any;
};

const BookedLessonsSummary = ({
  assignedSupport,
  bookingDuration,
  host,
  ...rest
}: Props) => {
  return (
    <Flex
      direction={["column", "row"]}
      p={[5, 5]}
      bg="neutral.100"
      borderWidth="2xs"
      rounded="fbRadius"
      mx={[5, 6]}
      {...rest}
    >
      <Flex direction={["column", "row"]}>
        <Icon
          name="checkmark"
          color="green.500"
          size={8}
          mb={[5, 0]}
          mr={[0, 5]}
        />

        <Stack flex={1}>
          <Text fontWeight="bold" lineHeight="none">
            Booked lessons
          </Text>
          <Flex align="center" justify="space-between">
            <Text>
              {getWeekDay(bookingDuration.from, "shortDay")},{" "}
              {format(bookingDuration.from, "MMM Do")}
            </Text>

            <Icon name="chevron-right" mx={5} />

            <Text>
              {getWeekDay(bookingDuration.to, "shortDay")},{" "}
              {format(bookingDuration.to, "MMM Do")}
            </Text>
          </Flex>

          <Button
            mt={5}
            as="a"
            colorScheme="blue"
            href={`${host}${bookingDuration.bookingUrl}`}
          >
            Go to your booking
          </Button>
        </Stack>
      </Flex>
    </Flex>
  );
};

export default BookedLessonsSummary;
